import { Container } from "react-bootstrap";
import classes from "./Description.module.scss";
import WideIMG from "../../public/images/case-studies/vr-technology.jpeg";
import Image from "next/image";
import { NumberAnimation } from "../utilities/NumberAnimation";
import classNames from "classnames";
import { AnimationOnAppear } from "../utilities/AnimationOnAppear";
import { prepositions } from "../../libs/prepositons";
import { useTranslation } from "next-i18next";

export const vrTechHas = "vr-technology";

export function VRTechnology() {
  const { t } = useTranslation("case-studies");
  return (
    <Container id={vrTechHas} className={classes.mainContainer}>
      <h2 className={classes.title} id="vr-technology">
        {prepositions(t("vr_technology.main_title"))}
      </h2>
      <p className={classes.description}>
        {prepositions(t("vr_technology.main_description"))}
      </p>
      <div className="d-flex justify-content-center">
        <div className="my-6 col col-lg-6 mx-auto">
          <Image
            src={WideIMG}
            alt="VRTechnology"
            objectFit="cover"
            layout="responsive"
          />
        </div>
      </div>
      <AnimationOnAppear animationClassName={classes.slideFromRight}>
        <div className={classNames(classes.paper, "bg-primary")}>
          {prepositions(t("vr_technology.main_description1"))}
        </div>
      </AnimationOnAppear>
      <AnimationOnAppear
        animationClassName={classes.opacity}
        duringDelayClassName={classes.noOpacity}
        delay={800}
      >
        <div>
          <div className={classes.divider} />
          <div className={classes.highlightsContainer}>
            <div className={classes.highlightContainer}>
              <NumberAnimation
                value={10}
                unit="+"
                className={classes.highlightValue}
                runOn="appear"
              />
              <span
                className={classes.highlightText}
                dangerouslySetInnerHTML={{
                  __html: t("vr_technology.highlight1"),
                }}
              />
            </div>
            <div className={classes.highlightContainer}>
              <NumberAnimation
                value={200}
                unit="+"
                className={classes.highlightValue}
                runOn="appear"
              />
              <span
                className={classes.highlightText}
                dangerouslySetInnerHTML={{
                  __html: t("vr_technology.highlight2"),
                }}
              />
            </div>
            <div className={classes.highlightContainer}>
              <NumberAnimation
                value={40}
                unit="+"
                className={classes.highlightValue}
                runOn="appear"
              />
              <span
                className={classes.highlightText}
                dangerouslySetInnerHTML={{
                  __html: t("vr_technology.highlight3"),
                }}
              />
            </div>
            <div className={classes.highlightContainer}>
              <NumberAnimation
                value={200}
                unit="+"
                className={classes.highlightValue}
                runOn="appear"
              />
              <span
                className={classes.highlightText}
                dangerouslySetInnerHTML={{
                  __html: t("vr_technology.highlight4"),
                }}
              />
            </div>
          </div>
          <div className={classes.divider} />
          <p className={classes.description}>
            {prepositions(t("vr_technology.our_work1"))}
          </p>
          <div className={classNames(classes.row, "my-8")}>
            <AnimationOnAppear animationClassName={classes.slideFromLeft}>
              <div
                className={classNames(
                  classes.paper,
                  "col-sm-12 col-lg-6",
                  "bg-primary"
                )}
              >
                {prepositions(t("vr_technology.our_work2"))}
              </div>
            </AnimationOnAppear>
            <AnimationOnAppear animationClassName={classes.slideFromRight}>
              <div
                className={classNames(
                  classes.paper,
                  "col-sm-12 col-lg-6",
                  "bg-primary"
                )}
              >
                {prepositions(t("vr_technology.our_work3"))}
              </div>
            </AnimationOnAppear>
          </div>
          <AnimationOnAppear
            animationClassName={classes.opacity}
            duringDelayClassName={classes.noOpacity}
            delay={800}
          >
            <div>
              <div className={classes.divider} />
              <h3 className={classes.subtitle}>
                {prepositions(t("vr_technology.business_title"))}
              </h3>
              <div className={classNames(classes.row, "mt-4")}>
                <div>
                  <ul>
                    <AnimationOnAppear
                      animationClassName={classes.opacity}
                      duringDelayClassName={classes.noOpacity}
                    >
                      <li
                        className={classes.listItem}
                        dangerouslySetInnerHTML={{
                          __html: prepositions(
                            t("vr_technology.business_point1")
                          ),
                        }}
                      />
                    </AnimationOnAppear>
                    <AnimationOnAppear
                      animationClassName={classes.opacity}
                      duringDelayClassName={classes.noOpacity}
                      delay={600}
                    >
                      <li
                        className={classes.listItem}
                        dangerouslySetInnerHTML={{
                          __html: prepositions(
                            t("vr_technology.business_point2")
                          ),
                        }}
                      />
                    </AnimationOnAppear>
                  </ul>
                </div>
                <div>
                  <ul>
                    <AnimationOnAppear
                      animationClassName={classes.opacity}
                      duringDelayClassName={classes.noOpacity}
                      delay={1200}
                    >
                      <li
                        className={classes.listItem}
                        dangerouslySetInnerHTML={{
                          __html: prepositions(
                            t("vr_technology.business_point3")
                          ),
                        }}
                      />
                    </AnimationOnAppear>
                  </ul>
                </div>
              </div>
              <AnimationOnAppear
                animationClassName={classes.slideFromRight}
                delay={1800}
              >
                <div className={classNames(classes.paper, "bg-primary")}>
                  <b>{prepositions(t("vr_technology.benefits_title"))}</b>
                  <br />
                  <div className={classNames(classes.wrap, "mt-3")}>
                    <div>{prepositions(t("vr_technology.benefit1"))}</div>
                    <div>{prepositions(t("vr_technology.benefit2"))}</div>
                    <div>{prepositions(t("vr_technology.benefit3"))}</div>
                    <div>{prepositions(t("vr_technology.benefit4"))}</div>
                  </div>
                  {prepositions(t("vr_technology.benefit5"))}
                </div>
              </AnimationOnAppear>
              <AnimationOnAppear
                animationClassName={classes.opacity}
                duringDelayClassName={classes.noOpacity}
                delay={2000}
              >
                <div className={classNames("mb-6 mt-3")}>
                  {prepositions(t("vr_technology.business_info"))}
                </div>
              </AnimationOnAppear>
            </div>
          </AnimationOnAppear>
        </div>
      </AnimationOnAppear>
    </Container>
  );
}
